//* THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
export default {
  af: "Afganistan",
  za: "Afrika Selatan",
  al: "Albania",
  dz: "Aljazair",
  us: "Amerika Serikat",
  ad: "Andorra",
  ao: "Angola",
  ai: "Anguilla",
  aq: "Antarktika",
  ag: "Antigua dan Barbuda",
  sa: "Arab Saudi",
  ar: "Argentina",
  am: "Armenia",
  aw: "Aruba",
  au: "Australia",
  at: "Austria",
  az: "Azerbaijan",
  bs: "Bahama",
  bh: "Bahrain",
  bd: "Bangladesh",
  bb: "Barbados",
  nl: "Belanda",
  bq: "Belanda Karibia",
  by: "Belarus",
  be: "Belgia",
  bz: "Belize",
  bj: "Benin",
  bm: "Bermuda",
  bt: "Bhutan",
  bo: "Bolivia",
  ba: "Bosnia dan Herzegovina",
  bw: "Botswana",
  br: "Brasil",
  bn: "Brunei",
  bg: "Bulgaria",
  bf: "Burkina Faso",
  bi: "Burundi",
  td: "Cad",
  cz: "Ceko",
  cl: "Cile",
  ci: "Côte d’Ivoire",
  cw: "Curaçao",
  dk: "Denmark",
  dm: "Dominika",
  ec: "Ekuador",
  sv: "El Salvador",
  er: "Eritrea",
  ee: "Estonia",
  sz: "eSwatini",
  et: "Etiopia",
  fj: "Fiji",
  ph: "Filipina",
  fi: "Finlandia",
  ga: "Gabon",
  gm: "Gambia",
  ge: "Georgia",
  gs: "Georgia Selatan & Kep. Sandwich Selatan",
  gh: "Ghana",
  gi: "Gibraltar",
  gd: "Grenada",
  gl: "Grinlandia",
  gp: "Guadeloupe",
  gu: "Guam",
  gt: "Guatemala",
  gg: "Guernsey",
  gn: "Guinea",
  gq: "Guinea Ekuatorial",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  gf: "Guyana Prancis",
  ht: "Haiti",
  hn: "Honduras",
  hk: "Hong Kong DAK Tiongkok",
  hu: "Hungaria",
  in: "India",
  id: "Indonesia",
  gb: "Inggris Raya",
  iq: "Irak",
  ir: "Iran",
  ie: "Irlandia",
  is: "Islandia",
  il: "Israel",
  it: "Italia",
  jm: "Jamaika",
  jp: "Jepang",
  de: "Jerman",
  je: "Jersey",
  dj: "Jibuti",
  nc: "Kaledonia Baru",
  kh: "Kamboja",
  cm: "Kamerun",
  ca: "Kanada",
  kz: "Kazakstan",
  ke: "Kenya",
  ax: "Kepulauan Aland",
  ky: "Kepulauan Cayman",
  cc: "Kepulauan Cocos (Keeling)",
  ck: "Kepulauan Cook",
  fk: "Kepulauan Falkland",
  fo: "Kepulauan Faroe",
  mp: "Kepulauan Mariana Utara",
  mh: "Kepulauan Marshall",
  nf: "Kepulauan Norfolk",
  pn: "Kepulauan Pitcairn",
  sb: "Kepulauan Solomon",
  sj: "Kepulauan Svalbard dan Jan Mayen",
  um: "Kepulauan Terluar A.S.",
  tc: "Kepulauan Turks dan Caicos",
  vi: "Kepulauan Virgin Amerika Serikat",
  vg: "Kepulauan Virgin Britania Raya",
  wf: "Kepulauan Wallis dan Futuna",
  kg: "Kirgistan",
  ki: "Kiribati",
  co: "Kolombia",
  km: "Komoro",
  cg: "Kongo - Brazzaville",
  cd: "Kongo - Kinshasa",
  kr: "Korea Selatan",
  kp: "Korea Utara",
  cr: "Kosta Rika",
  hr: "Kroasia",
  cu: "Kuba",
  kw: "Kuwait",
  la: "Laos",
  lv: "Latvia",
  lb: "Lebanon",
  ls: "Lesotho",
  lr: "Liberia",
  ly: "Libia",
  li: "Liechtenstein",
  lt: "Lituania",
  lu: "Luksemburg",
  mg: "Madagaskar",
  mo: "Makau DAK Tiongkok",
  mk: "Makedonia Utara",
  mv: "Maladewa",
  mw: "Malawi",
  my: "Malaysia",
  ml: "Mali",
  mt: "Malta",
  ma: "Maroko",
  mq: "Martinik",
  mr: "Mauritania",
  mu: "Mauritius",
  yt: "Mayotte",
  mx: "Meksiko",
  eg: "Mesir",
  fm: "Mikronesia",
  md: "Moldova",
  mc: "Monako",
  mn: "Mongolia",
  me: "Montenegro",
  ms: "Montserrat",
  mz: "Mozambik",
  mm: "Myanmar (Burma)",
  na: "Namibia",
  nr: "Nauru",
  np: "Nepal",
  ne: "Niger",
  ng: "Nigeria",
  ni: "Nikaragua",
  nu: "Niue",
  no: "Norwegia",
  om: "Oman",
  pk: "Pakistan",
  pw: "Palau",
  pa: "Panama",
  pg: "Papua Nugini",
  py: "Paraguay",
  pe: "Peru",
  pl: "Polandia",
  pf: "Polinesia Prancis",
  pt: "Portugal",
  fr: "Prancis",
  pr: "Puerto Riko",
  bv: "Pulau Bouvet",
  hm: "Pulau Heard dan Kepulauan McDonald",
  im: "Pulau Man",
  cx: "Pulau Natal",
  qa: "Qatar",
  cf: "Republik Afrika Tengah",
  do: "Republik Dominika",
  re: "Réunion",
  ro: "Rumania",
  ru: "Rusia",
  rw: "Rwanda",
  eh: "Sahara Barat",
  bl: "Saint Barthélemy",
  sh: "Saint Helena",
  kn: "Saint Kitts dan Nevis",
  lc: "Saint Lucia",
  mf: "Saint Martin",
  pm: "Saint Pierre dan Miquelon",
  vc: "Saint Vincent dan Grenadine",
  ws: "Samoa",
  as: "Samoa Amerika",
  sm: "San Marino",
  st: "Sao Tome dan Principe",
  nz: "Selandia Baru",
  sn: "Senegal",
  rs: "Serbia",
  sc: "Seychelles",
  sl: "Sierra Leone",
  sg: "Singapura",
  sx: "Sint Maarten",
  cy: "Siprus",
  sk: "Slovakia",
  si: "Slovenia",
  so: "Somalia",
  es: "Spanyol",
  lk: "Sri Lanka",
  sd: "Sudan",
  ss: "Sudan Selatan",
  sy: "Suriah",
  sr: "Suriname",
  se: "Swedia",
  ch: "Swiss",
  tw: "Taiwan",
  tj: "Tajikistan",
  cv: "Tanjung Verde",
  tz: "Tanzania",
  th: "Thailand",
  tl: "Timor Leste",
  cn: "Tiongkok",
  tg: "Togo",
  tk: "Tokelau",
  to: "Tonga",
  tt: "Trinidad dan Tobago",
  tn: "Tunisia",
  tr: "Turki",
  tm: "Turkimenistan",
  tv: "Tuvalu",
  ug: "Uganda",
  ua: "Ukraina",
  ae: "Uni Emirat Arab",
  uy: "Uruguay",
  uz: "Uzbekistan",
  vu: "Vanuatu",
  va: "Vatikan",
  ve: "Venezuela",
  vn: "Vietnam",
  io: "Wilayah Inggris di Samudra Hindia",
  ps: "Wilayah Palestina",
  tf: "Wilayah Selatan Perancis",
  ye: "Yaman",
  jo: "Yordania",
  gr: "Yunani",
  zm: "Zambia",
  zw: "Zimbabwe",
};
